<pbc-filter [config]="ObjektArtsFilterConfig" [filter]="objektArts.filter$ | async" (filterChange)="objektArts.filter$.next($event)"></pbc-filter>
